import { FC } from 'react'
import classNames from 'classnames'
import DemoPeriodBadge from '@UI/New/DemoPeriodBadge'
import NewCourseBadge from '@UI/New/NewCourseBadge'
import { getStudentCourseIndicatorsInfo } from '@/helpers/courseIndicators'
import cn from './index.module.css'

interface IStudentCourseIndicators {
  student?: Record<string, any> | null
  className?: string
  compact?: boolean
}

const StudentCourseIndicators: FC<IStudentCourseIndicators> = ({
  student,
  className,
  compact = false,
}) => {
  const indicators = getStudentCourseIndicatorsInfo(student)

  if (!indicators.hasDemo && !indicators.hasNewCourse) return null

  return (
    <span className={classNames(cn.wrapper, className)}>
      {indicators.hasDemo && (
        <DemoPeriodBadge
          order={indicators.demoOrder}
          compact={compact}
          studentSummary
        />
      )}
      {indicators.hasNewCourse && (
        <NewCourseBadge
          order={indicators.newOrder}
          compact={compact}
          studentSummary
        />
      )}
    </span>
  )
}

export default StudentCourseIndicators
